export const ItemTypes = {
  BOX: 'box',
  COMMENT: 'comment',
  NEW_COMMENT: 'new_comment',
};
